import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import { ButtonDefault } from '../../helpers/UIElements';

import { colors } from '../../styles';
import VideoModal from '../../components/VideoModal';
import icons from '../../components/IconsList';

const styles = css`
  margin: 50px 0 0;
  display: flex;
  flex-wrap: wrap;
  @media(min-width: 992px) {
    margin: 3px 0 0;
  }
  .VideoSection_background {
    background-position: center;
    background-repeat: no-repeat;
    height: 290px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .VideoSection_boxWrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media(min-width: 576px) {
      align-items: flex-end;
      max-width: 550px;
    }
  }
  .VideoSection_video {
    padding: 0 0 77px;
    align-items: center;
  }
  .VideoSection_videoWrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.66);
    height: 192px;
    @media(min-width: 576px) {
      max-width: 550px;
    }
  }
  .VideoSection_boxTitle {
    background-color: rgba(214, 155, 41, 0.75);
    font-weight: 300;
    font-size: 42px;
    color: #FFFFFF;
    letter-spacing: 1px;
    text-align: center;
    line-height: 42px;
    padding: 35px 15px;
    width: 100%;
    margin: 0;
    @media(min-width: 576px) {
      padding: 35px 55px;
      font-size: 54px;
      letter-spacing: 1.38px;
      line-height: 51px;
    }
    @media(min-width: 992px) {
      padding: 45px 55px;
    }
  }
  .VideoModal_wrapper {
    width: 74px;
    height: 74px;
    background-color: ${colors.color1};
    border-radius: 50%;
    transition: all .3s ease-out;
    @media(min-width: 576px) {
      margin: 0 50px 0 0;
    }
    @media(min-width: 992px) {
      background-color: ${colors.color1};
      width: 92px;
      height: 92px;
      margin: 0;
    }
    &:hover {
      opacity: .85;
      transform: scale(1.05);
    }
  }
  .VideoModal_btn {
    width: 100%;
    height: 100%;
    &:focus {
      outline: none;
    }
  }
  .VideoSection_playBtn {
    width: 100%;
    height: 100%;
    display: flex;
    cursor: pointer;
    position: relative;
    &:focus {
      outline: none;
    }
    &::after {
      content: '';
      background-image: url(${icons.playWhite});
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      width: 29px;
      height: 20px;
      margin: auto;
    }
  }
  .VideoSection_btn {
    background-color: #FFFFFF;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all .3s ease-out;
    z-index: 1;
    @media(min-width: 992px) {
      height: 53px;
    }
    &:hover {
      transform: scale(1.05);
      box-shadow: rgba(0, 0, 0, 0.2) 0px 15px 20px 0px;
    }
    .ButtonDefault_link {
      width: 188px;
      @media(min-width: 992px) {
        width: 223px;
      }
    }
  }
  .VideoSection_watch {
    font-weight: 300;
    font-size: 27px;
    color: #000000;
    letter-spacing: 0.84px;
    text-align: center;
  }
`;

function VideoSection({ content }) {
  return (
    <div className={styles}>
      <div style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, 'image.contentUrl'), { width: 1000, height: 1000, preserve: true })})` }} className="col-12 col-lg-6 VideoSection_background px-0" >
        <hgroup className="VideoSection_boxWrapper">
          <h3 className="VideoSection_boxTitle">{get(content, 'title')}</h3>
          <div className="VideoSection_btn mb-4">
            <ButtonDefault>
              <Link name="our-construction-process" className="ButtonDefault_link"><span>{get(content, 'button_text')}</span></Link>
            </ButtonDefault>
          </div>
          <span className="d-lg-none">
            <VideoModal videoPlayer={get(content, 'video.contentUrl')}><span className="VideoSection_playBtn" /></VideoModal>
          </span>
        </hgroup>
      </div>
      <div style={{ backgroundImage: `url(${buildThumbnailUrl(get(content, 'video_background.contentUrl'), { width: 1000, height: 1000, preserve: true })})` }} className="col-12 col-lg-6 d-none d-lg-flex px-0 VideoSection_video" >
        <hgroup className="VideoSection_videoWrapper">
          <h4 className="VideoSection_watch mr-3">Watch Video</h4>
          <VideoModal videoPlayer={get(content, 'video.contentUrl')}><span className="VideoSection_playBtn" /></VideoModal>
        </hgroup>
      </div>
    </div>
  );
}

VideoSection.propTypes = {
  content: PropTypes.object.isRequired,
};

export default VideoSection;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/VideoSection.js